import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-programs-search',
  templateUrl: './programs-search.component.html',
  styleUrls: ['./programs-search.component.css']
})
export class ProgramsSearchComponent implements OnInit {
  @Input() searchText: string
  @Output() searchTextChange = new EventEmitter<string>()
  @Output() searchTextChanged = new EventEmitter<string>()

  constructor() { }

  ngOnInit() {
  }

  onSearchTextChanged() {
    this.searchTextChange.emit(this.searchText);
    this.searchTextChanged.emit(this.searchText);
  }

}
